// ─── "נושאים פתוחים" (sprint 20, stage 3) ────────────────────────────────────
//
// Code only. A development from the last TOPIC_DAYS days about a holding, for
// which the calendar already has a dated event of the same company · the
// next report (Finnhub). One line each:
//   "<title>" · "פתוח מאז <date> · דוח רבעוני ב-<date>"
// Nothing here says the event will settle anything: it is the next dated
// thing on the calendar for that company, and the line says only that.
// The developments on the cards above are not repeated here.

import { HIDDEN_TYPES } from "./intelRank";

export const TOPIC_DAYS = 14;
export const MAX_TOPICS = 4;

// The Israel calendar, as on the rest of the page.
const ddmm = iso => new Date(iso).toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", timeZone: "Asia/Jerusalem" });
const israelDay = d => new Date(d).toLocaleDateString("en-CA", { timeZone: "Asia/Jerusalem" });
// The newest report of the development the reader can open · its source.
const sourceOf = c => [...(c.articles || [])].filter(a => /^https?:\/\//.test(a?.url || "")).sort((a, b) => b.datetime - a.datetime)[0] || null;

/**
 * clusters · intel_clusters rows · held · { SYMBOL: weight% } · calendar ·
 * earnings rows { symbol, date } · skip · ids already on a card
 * → [{ id, symbol, title, since, source: { name, url }, event: { label, date, dateText } }],
 *   nearest event first. A kind held back from the cards (HIDDEN_TYPES) is
 *   held back here too, and a development with no source to open is not a
 *   topic (stage 3 review).
 */
export function openTopics({ clusters, held, calendar, skip = [], now = new Date() }) {
  const since = now.getTime() - TOPIC_DAYS * 86400000;
  const today = israelDay(now);
  const nextBySymbol = {};
  for (const r of calendar || []) {
    if (!r?.symbol || !r.date || r.date < today) continue;
    if (!nextBySymbol[r.symbol] || r.date < nextBySymbol[r.symbol]) nextBySymbol[r.symbol] = r.date;
  }
  const skipSet = new Set(skip);
  const out = [];
  // One line per company and kind: the newest development of it.
  const seenKey = new Set();
  const sorted = [...(clusters || [])].sort((a, b) => Date.parse(b.last_at) - Date.parse(a.last_at));
  for (const c of sorted) {
    if (skipSet.has(c.id) || !(held?.[c.symbol] > 0) || !c.title_he) continue;
    if (HIDDEN_TYPES.has(c.event_type)) continue;
    const src = sourceOf(c);
    if (!src) continue;
    if (!(Date.parse(c.first_at) >= since)) continue;
    const date = nextBySymbol[c.symbol];
    if (!date) continue;
    const key = `${c.symbol}|${c.event_type}`;
    if (seenKey.has(key)) continue;
    seenKey.add(key);
    out.push({ id: c.id, symbol: c.symbol, title: c.title_he, since: ddmm(c.first_at), source: { name: src.source, url: src.url }, event: { label: "דוח רבעוני", date, dateText: ddmm(`${date}T12:00:00Z`) } });
  }
  return out.sort((a, b) => a.event.date.localeCompare(b.event.date)).slice(0, MAX_TOPICS);
}
